import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  Bold,
  ClassicEditor,
  Clipboard,
  Essentials,
  FontColor,
  Heading,
  HorizontalLine,
  Image,
  ImageUpload,
  Italic,
  Link,
  List,
  Mention,
  Paragraph,
  Table,
  Undo
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { FieldInputProps, FormikProps } from 'formik';
import React from 'react';
import { normalizeHtmlOnSave, prepareHtmlForEditor } from '../../utils/richTextHtml';

// Add this CSS to your global styles or component
const editorStyles = `
  .ck-content ul {
    list-style-type: disc;
    padding-left: 40px;
  }
  .ck-content ul li {
    list-style-type: inherit;
  }
`;

interface EditorProps {
  field: FieldInputProps<any>;
  form: FormikProps<any>;
  label?: string;
  customItems?: string[];
}

const Editor: React.FC<EditorProps> = ({ field, form, label, customItems }) => {
  const handleEditorChange = (_event: unknown, editor: { getData: () => string }) => {
    const data = normalizeHtmlOnSave(editor.getData());
    form.setFieldValue(field.name, data);
  };
  const isInvalid = !!form.errors[field.name] && !!form.touched[field.name];

  return (
    <div className={isInvalid ? 'is-invalid' : ''}>
      <style>{editorStyles}</style>
      {label && <label>{label}</label>}
      <CKEditor
        editor={ClassicEditor}
        data={prepareHtmlForEditor(field.value)}
        onChange={handleEditorChange}
        config={{
          toolbar: {
            items: customItems || ['bulletedList', 'bold', 'italic', 'link', 'undo', 'redo']
          },
          list: {
            properties: {
              styles: true,
              startIndex: true,
              reversed: true
            }
          },
          plugins: [
            Bold,
            Essentials,
            FontColor,
            Heading,
            HorizontalLine,
            Image,
            ImageUpload,
            Italic,
            Mention,
            Paragraph,
            Table,
            Undo,
            List,
            Link,
            Clipboard
          ]
        }}
      />
    </div>
  );
};

export default Editor;
